
import { XsAwait } from '@src/app/xs/controllers/await.class';
import { FdmPlugin, FdmPluginInterface } from '../plugins';


const Cesium = (<any>window).Cesium;

// const tzlookup = require("tz-lookup");

export class LightController extends FdmPlugin implements FdmPluginInterface {

    static meta = {

        label: 'PLUGINS.LIGHT_CONTROLLER.LABEL',
        name: 'light-controller',
        translator: 'PLUGINS.LIGHT_CONTROLLER',
        tooltip: 'PLUGINS.LIGHT_CONTROLLER.TOOLTIP',
        shortcut: true,
        icon: 'cloud-sun',

        // hideHeader: true,
        // offsetX: 'context',
        // offsetY: 'context',

        category: FdmPlugin.category.generic,

        types: [ FdmPlugin.types.cameraController ],
        cardinality: FdmPlugin.cardinality.one,
    };

    // our three types of light
    CUSTOM:string = 'MORNING';
    CURRENT:string = 'ACTUAL';
    FIXED:string = 'FIXED';

    controls:any = {
        type: { value: this.CURRENT, type:'select', options: [ this.CURRENT, this.CUSTOM, this.FIXED ], translateOptions:true },
        time: { value:'10', type:'slider', min:0, max:23, step:1, noshow:true },
        info: { value:'', type:'info' },
        intensity: { value:2.0, type:'slider', min:0.1, max:4, step:0.01 },
        shadows: { value:true, type:'check' }
    }

    timeController:any = null;

    itemInjected() {

        // recheck every 9 seconds to recalibrate our camera position
        this.pulseSeconds = 9;

        this.timeController = this.services.findPlugin ( 'time-controller', 'camera-plugins' );

        XsAwait.until( 'services.mapService.viewer.scene', this ).then ( _ => {

            // console.log('@@@@@@@@@@@@ light-controller @@@@@@@@@@@@@@@@ THESE are OK', theseOnes );

            // first time run
            this.refresh();

            // start pulsing
            this.startPulse();

        });
        
        
        // if we use fixed light, update the light direction as we move the camera around
        this.services.mapService.viewer.scene.preRender.addEventListener( (scene) => {
            // console.log('$',me.controls.type.value == me.meta.translator + '.FIXED',me.controls.type.value,me.meta.translator + '.FIXED');
            if ( this.controls.type.value == this.FIXED ) {

                scene.light.direction = Cesium.Cartesian3.clone(
                    this.services.mapService.viewer.scene.camera.directionWC,
                    this.services.mapService.viewer.scene.light.direction
                );
                // console.log('#',scene.light.direction);
            }
        });
    }

    pulse() {
        this.refresh();

        // if we use fixed light, update the light direction as we move the camera around
        this.services.mapService.viewer.scene.preRender.addEventListener( (scene) => {
            // console.log('$',me.controls.type.value == me.meta.translator + '.FIXED',me.controls.type.value,me.meta.translator + '.FIXED');
            if ( this.controls.type.value == this.FIXED ) {

                scene.light.direction = Cesium.Cartesian3.clone(
                    this.services.mapService.viewer.scene.camera.directionWC,
                    this.services.mapService.viewer.scene.light.direction
                );
                // console.log('#',scene.light.direction);
            }
        });
    }

    refresh( newvalue = null, section:any = null ) {

        if ( !this.services.mapService || !this.services.mapService.viewer || !this.services.mapService.viewer.scene ) {
            return;
        }

        this.services.mapService.viewer.scene.globe.enableLighting = true;
        this.services.mapService.viewer.scene.globe.dynamicAtmosphereLighting = true;
        this.services.mapService.viewer.scene.globe.dynamicAtmosphereLightingFromSun = true;

        // console.log('@@@@',this.services.mapService.viewer.scene.postProcessStages );


        // the time controller checks where we are in the world (and sets the timezone properly)
        if ( this.timeController ) {
            this.timeController.refresh();
        }

        // no point in doing this if we haven't got any dates or camera location yet
        if ( this.services.mapService && this.services.mapService.cameralocation && this.services.mapService.cameralocation.dateCamera && this.services.mapService.cameralocation.dateClient ) {

            // check in with mama
            super.refresh ( newvalue, section );

            let heredate = this.services.mapService.cameralocation.dateCamera;

            if ( this.controls.type.value == this.FIXED ) {

                this.services.mapService.viewer.scene.light = new Cesium.DirectionalLight({
                    direction: this.services.mapService.viewer.scene.camera.directionWC,
                    intensity: this.controls.intensity.value
                });
                this.controls.time.noshow = true;

            } else {
                
                if ( this.controls.type.value == this.CUSTOM ) {

                    let toffset = this.controls.time.value - heredate.getHours();
                    this.services.mapService.cameralocation.dateClient.setHours(this.services.mapService.cameralocation.dateClient.getHours()+toffset);

                    this.controls.time.noshow = false;
                } else {

                    this.services.mapService.cameralocation.dateClient.setHours(this.services.mapService.cameralocation.dateClient.getHours() );

                    this.controls.time.noshow = true;
                }

                // we set the time in Cesium with an ISO date
                this.setTime( this.services.mapService.cameralocation.dateClient.toISOString() );

                // Julian time for simulated time (if custom time)
                let nstr = this.services.mapService.cameralocation.dateClient.toTimeString(); 
                this.services.mapService.cameralocation.simulatedTimeLabel = nstr.substr(0,nstr.indexOf(' ') - 3);

                this.services.mapService.viewer.scene.light = new Cesium.SunLight();
                this.services.mapService.viewer.scene.light.intensity = this.controls.intensity.value;

            }

            this.services.mapService.viewer.shadows = this.controls.shadows.value;
            // console.log('@@', this.mapService.viewer.shadowMap );

        }

    }

    end() {
        this.services.mapService.viewer.scene.globe.enableLighting = false;
        this.services.mapService.viewer.scene.globe.dynamicAtmosphereLighting = false;
        this.services.mapService.viewer.shadows = false;
    }

    setTime ( iso8601:any ) {
        
        var currentTime = Cesium.JulianDate.fromIso8601(iso8601);
        this.services.mapService.viewer.clock.currentTime = currentTime;

    }

}
